"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const clientProjectEnvVariableGetNameOnSystem = ({ name, projectId, }) => `${projectId.toUpperCase()}_${name}`;
exports.default = clientProjectEnvVariableGetNameOnSystem;
